import Container from '@/components/Container';
import Header from '@/components/Header';
import React, { useState, useEffect } from 'react';
import MapComponent from './MapComponent';
import { useCollectionOrders } from '@/hooks/collectionOrder/useCollectionOrders';
import { useMaps } from '@/hooks/map/useMap';
import Spinner from '@/components/Spinner';
import { DateRange } from 'react-day-picker';
import Filters from './filters/Filters';
import { getUserId, getUserRole } from '@/utils/auth.util';

type PropsMapView = {};

const MapView: React.FC<PropsMapView> = () => {
  const userRole = getUserRole();
  const [collectorId, setCollectorId] = useState<string | null>(null);

  useEffect(() => {
    if (userRole === 'collector') {
      setCollectorId(getUserId());
    }
  }, [userRole]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState(() => ({
    status: '',
    selectedCollector: collectorId || '',
    dateRange: undefined as DateRange | undefined,
  }));

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      selectedCollector: collectorId || '',
    }));
  }, [collectorId]);

  const { coordinates, refresh, loading, error } = useMaps(
    searchTerm,
    filters.status,
    filters.selectedCollector,
    filters.dateRange
  );

  const handleFiltersChange = (newFilters: {
    status: string;
    selectedCollector: string;
    dateRange: DateRange | undefined;
  }) => {
    setFilters(newFilters);
  };

  return (
    <Container isSmallScreenReady>
      <Header placeholder='Search Map' setSearchTerm={setSearchTerm} />

      <div className='h-[calc(100vh-100px)] p-4'>
        <div className='flex justify-between z-50'>
          <h1 className='font-semibold mb-4 text-[18px]'>Map view</h1>
          <Filters
            collectorIdExist={Boolean(collectorId)}
            onFiltersChange={handleFiltersChange}
          />
        </div>

        {error && (
          <div className='h-full flex items-center justify-center'>{error}</div>
        )}
        {loading ? (
          <div className='h-full flex items-center justify-center'>
            <Spinner />
          </div>
        ) : (
          <MapComponent coordinates={coordinates} />
        )}
      </div>
    </Container>
  );
};

export default MapView;
